<div class="justify-content-center additional-info-header m-b-25" translate>dimbo.i18n.sh.mu.header</div>
<div class="straight-line m-b-25"></div>
<div mat-dialog-content>
    <ngx-spinner></ngx-spinner>
    <div class="container-box">        
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field class="">
                    <mat-label translate>dimbo.i18n.label.currentMileage</mat-label>
                    <input matInput [(ngModel)]="mileagevalue">
                </mat-form-field>
            </div>
            <div class="col-sm-6">
                <section class="example-section m-t-10 m-l-10">
                    <mat-radio-group [(ngModel)]="mileageunit">
                    <mat-radio-button style="margin-left: 2px ;" value="km">km</mat-radio-button>
                    <mat-radio-button class="m-l-5" value="mi">mi</mat-radio-button>
                    </mat-radio-group>

                </section>
            </div>
            
        </div>
        <br>
    
        <!-- <div mat-dialog-actions> -->
        <div class="container m-b-15">    
            <div class="row">
                <div class="col-sm-6">
                    <button mat-raised-button class="btn float-left" (click)="close()"> <span translate>dimbo.i18n.button.close</span></button>
                </div>
                <div class="col-sm-5">
                    <button mat-raised-button color="primary" (click)="updateServiceMileage()" class="btn float-right"><span translate>dimbo.i18n.button.ok</span></button>
                </div>
            </div>
        </div>
    </div>

</div>
